import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";

/* img imports */
import recipesCarrotChef from "../assets/images/recipes/recipes-carrot-chef.png";
import recipeMenuBubble from "../assets/images/recipes/recipe-menu-bubble.png";
import ytThumb from "../assets/images/recipes/yt-icon-thumb.png";
import recipeClickPointer from "../assets/images/click-pointer.png";

/* data import */
import recipesVideoData from "../data/recipesVideoData";
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";
import RecipesSlider from "../components/RecipesSlider";
import { recipeData } from "../data/recipeMenuData";

import RecipeMenuModal from "../components/modals/RecipesInfoModal";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const Recipes = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    if (/^https?:\/\//i.test(pageName)) {
      window.open(pageName, "_blank", "noopener,noreferrer");
    } else {
      navigate(pageName);
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const [showUnmuteBtn, setShowUnmuteBtn] = useState(false);

  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }
  }, []);

  const handleVideoPreview = (videoId, index) => {
    setActiveIndex(index);
    const previewWrapper = document.getElementById("ytPreviewWrapper");
    const previewWrapperInitial = document.getElementById(
      "ytPreviewWrapperInitial"
    );

    if (previewWrapper.classList.contains("d-none")) {
      previewWrapper.classList.remove("d-none");
      previewWrapper.classList.add("disable-click");
    }
    if (!previewWrapperInitial.classList.contains("d-none")) {
      previewWrapperInitial.classList.add("d-none");
    }

    if (window.playerInstance) {
      window.playerInstance.destroy();
    }

    // const iframe = previewWrapper.querySelector("iframe");

    // iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&loop=1&controls=0&playlist=${videoId}&rel=0`;

    // iframe.id = "ytPlayer";

    window.playerInstance = new window.YT.Player("ytPlayer", {
      videoId,
      playerVars: {
        autoplay: 1,
        controls: 0,
        rel: 0,
        loop: 1,
        playlist: videoId,
        mute: 1, // muted autoplay always works
      },
      events: {
        onReady: (event) => {
          event.target.playVideo();
          setShowUnmuteBtn(true); // show unmute button
        },
      },
    });
  };

  const handleUnmute = () => {
    if (window.playerInstance) {
      window.playerInstance.unMute();
      setShowUnmuteBtn(false);
    }
  };

  const handleRecipeMenuClick = (value) => {
    const modalElement = document.getElementById("recipeMenuModal");
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  };

  return (
    <>
      <PageTransition />
      <BackArrow handleRedirect={handleRedirect} linkName="/inner-tents" />
      <div className="page-main-wrapper recipes-page-main-wrapper">
        <div
          className="recipe-menu-bubble"
          onClick={() => handleRecipeMenuClick()}
        >
          <img src={recipeMenuBubble} alt="recipe menu bubble" />
        </div>
        <div className="recipe-click-pointer">
          <img src={recipeClickPointer} alt="Click Pointer" />
        </div>

        <div className="recipes-tv-wrapper">
          <div
            className="recipes-preview-wrapper-initial"
            id="ytPreviewWrapperInitial"
            onClick={() => handleVideoPreview(recipesVideoData[0].youtubeLink)}
          >
            <img
              src={`https://i.ytimg.com/vi/${recipesVideoData[0].youtubeLink}/maxresdefault.jpg`}
              className="recipes-main-thumb"
              alt=""
            />
            <img src={ytThumb} className="recipes-thumb-initial" alt="" />
          </div>
          {showUnmuteBtn && (
            <div className="unmute-btn" onClick={handleUnmute}>
              <span class="material-symbols-rounded">volume_up</span>
              {/* Tap to Unmute */}
            </div>
          )}
          <div className="recipes-preview-wrapper d-none" id="ytPreviewWrapper">
            <div id="ytPlayer"></div>
            {/* <iframe
              id="ytPlayer"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen={true}
            ></iframe> */}
          </div>

          <RecipesSlider
            recipesVideoData={recipesVideoData.length && recipesVideoData}
            ytThumb={ytThumb}
            handleVideoPreview={handleVideoPreview}
            activeIndex={activeIndex}
          />
        </div>
        <div className="recipes-carrot-chef-wrapper">
          <img src={recipesCarrotChef} alt="recipes carrot chef" />
        </div>
        <div
          className="recipes-text-wrapper"
          onClick={() => {
            handleRedirect("https://www.youtube.com/@ChefAjayChopra");
          }}
        >
          *Videos used in this page are from Chef Ajay Chopra Official Youtube
          Channel
        </div>
      </div>
      <RecipeMenuModal recipeData={recipeData} />
      <MainDisclaimerModal />
    </>
  );
};

export default Recipes;
